import { CommonModule } from '@angular/common';
import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CheckboxCellRendererParams } from '../../../../../core/models/grid/checkbox-cell-renderer-params';
import { FormCellRendererBaseComponent } from '../form-cell-renderer-base/form-cell-renderer-base.component';

@Component({
    selector: 'app-check-box-cell-renderer',
    imports: [
        MatCheckboxModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatFormFieldModule,
        CommonModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './check-box-cell-renderer.component.html',
})
export class CheckBoxCellRendererComponent extends FormCellRendererBaseComponent<CheckboxCellRendererParams> {
    @ViewChild('inputElement') inputElement!: MatCheckbox;

    visuallyDisabled = false;

    agInit(params: CheckboxCellRendererParams): void {
        this.formControl = params.context.formArray
            .at(params.node.rowIndex)
            .get(params.column?.getColId()) as FormControl;

        if (params.visuallyDisabled) {
            this.visuallyDisabled = params.visuallyDisabled(params);
        }
    }

    onFocus(): void {
        if (this.shouldFocus()) {
            this.inputElement.focus();
            this.isFocusedState.set(true);
        }
    }
}
